import { AxiosResponse } from "axios";
import { BACKEND_API_URL } from "../config/config";
import { GetAPIParams } from "../models/queryService.model";
import QueryService from "../services/queryServices";
import { pageSize } from "../constants/common";
import { LineofBusiness } from "../models/LineofBusinessFilterData";

export const getBrandCostIndex = (category: string, customerId: any = null) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getMarginBrainData?category=${category.replace(
			/&/g,
			"%26"
		)}`;
		if (customerId) {
			url += `&customerId=${customerId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingDivsionDataByCustomer = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getPricingForCustomer?customer=${payload.customer}`;
		if (payload.divisionId) {
			url += `&divisionId=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getCrossSellCustomerList = (isUpSell: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = isUpSell
			? `/getUpSellCustomerList`
			: `/getCrossSellCustomerList`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getCrossSellItemListByCustomer = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCrossSellItemListByCustomer?customer=${payload.customer}&l1=${payload.l1}&l4=${payload.l4}`;
		if (payload.divisionId.length > 0) {
			url += `&location=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getBCIHistoricalTrend = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getBCIHistoricalTrend?itemId=${payload.itemId}&DivisionID=${payload.DivisionID}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const UpdateBrandCost = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateMarginBrainData`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const UpdateSaveReason = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/saveReasonBCI`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const UpdateBrandCostRec = (payload: any, flag: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateMarginBrainDataRec`;
		if (flag === 1 || flag === 2) {
			url += `?flag=${flag}`;
		}
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};

export const UpdateSKUData = (payload: any, acceptAll = false) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/updateSKUData`;
		if (acceptAll) {
			url += `?isAll=1`;
		}
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in updateSKUData update APi --", err);
		});
};

export const submitSKU = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/submitSKU`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in submitSKU update APi --", err);
		});
};

export const submitBCI = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/submitBCI`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in submitSKU update APi --", err);
		});
};

const fetchRetry: any = async (url: string, method: string, retry: any = 3) => {
	const queryService = new QueryService(BACKEND_API_URL);
	try {
		await queryService.runQuery(url, method, {}, (err: any, res: any) => {
			if (err) {
				if (retry === 0) {
					throw new Error(err);
				} else {
					return fetchRetry(url, method, retry - 1);
				}
			} else {
				return;
			}
		});
	} catch (e: any) {
		if (retry === 0) {
			throw new Error(e);
		} else {
			return fetchRetry(url, method, retry - 1);
		}
	}
};

export const getPerformanceOverviewData = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getVendorData`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getSKURationalisationData = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getSKUData`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const triggerADFPipeline = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/triggerPipeline`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not trigger pipeline");
		});
};

export const getPredictiveAlertsData = (isRefresh: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getPredictiveData?isRefresh=${isRefresh}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getCostToServeCustomers = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCostToServeCustomerList`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch customers");
		});
};

export const getCostToServeScenario = (customer: string) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCostToServeScenarios?customer=${customer}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch customer data");
		});
};

export const getAPI = (
	url: string,
	queryParamsinArrayOfObject: Array<GetAPIParams> = []
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		queryParamsinArrayOfObject.forEach(
			(param: GetAPIParams, index: number) => {
				if (index === 0) {
					url += "?";
				}
				url += `${param.key.replace(/&/g, "%26")}=${param.value.replace(
					/&/g,
					"%26"
				)}`;
				if (index < queryParamsinArrayOfObject.length - 1) {
					url += "&";
				}
			}
		);
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Error in getAPI method");
		});
};

export const putAPI = (url: string, payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};
	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log(
				`error in putAPI method of url - ${url} and Error is`,
				err
			);
		});
};
export const getUpSellOpportunities = (payload: any, location: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getUpSellOpportunityByCustomer?customer=${payload.customer}`;
		if (location.length > 0) {
			url += `&location=${location}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getUpSellRecommendationData = (payload: any, location: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getUpSellRecommendationData?customer=${payload.customer}`;
		if (location.length > 0) {
			url += `&location=${location}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getDropDaysPopUpData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCTSAdherence?customer=${payload.customer}&month=${payload.month}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getUpSellLevelFourRecommendationData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getLevelFourData?customer=${payload.customer}&l4=${payload.l4}&itemId=${payload.itemId}`;
		if (payload.divisionId.length > 0) {
			url += `&location=${payload.divisionId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getPricingMonthlyTrend = (
	custId: string,
	l4: string,
	divisionId: string
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = divisionId
			? `/getPricingMonthlyTrend?customerId=${custId}&l4=${l4}&divisionId=${divisionId}`
			: `/getPricingMonthlyTrend?customerId=${custId}&l4=${l4}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the Pricing monthly data !");
		});
};

export const UpdateUpSellRecommendationIncudeBit = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/saveUpSellItemData`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateUpSellRecommendation API --", err);
		});
};
export const savePricingExecutedPrice = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = "/savePricingExecutedPrice";
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};
	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("Error in saving execution price--", err);
		});
};

export const getCPCustomerList = async (payload: any, lob: LineofBusiness) => {
	const queryService = new QueryService(BACKEND_API_URL);



	const params = new URLSearchParams({
		lob
	});
	let url = `/getCPCustomerList?` + params.toString();
	const data: AxiosResponse<ResponseWrapper<Customer[]>> =
		await queryService.runQuery(url, "POST", payload);
	return data;
};

export const getCPSummaryData = async (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	let url = `/getCPSummaryData?`;
	const data = await queryService.runQuery(url, "POST", payload);
	return data;
};

export const getCPDetailForCustomer = async (payload: {
	customerId: string;
	District: string;
	projectFlag: string;
	dateRange: string;
}) => {
	const queryService = new QueryService(BACKEND_API_URL);
	let url = `/getCPDetailForCustomer`;
	const data: AxiosResponse<ResponseWrapper<CustomerDetails>> =
		await queryService.runQuery(url, "POST", payload);
	return data;
};

export const getCPBreakDownCustomerList = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = "/getCPBreakDownCustomerList";
		const data: AxiosResponse<ResponseWrapper<CustomerDropdown[]>> =
			await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch((err) => {
			console.log("Could Not fetch data");
			throw err;
		});
};

export const getWaterFallGraphData = (custId: any = "") => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = "/getCPBreakDownGraphData";
		if (custId) {
			url = `/getCPBreakDownGraphData?customerId=${custId}`;
		}
		const data: AxiosResponse<ResponseWrapper<PricingMarginWaterfall[]>> =
			await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData().then((data) => {
		return data;
	});
};

// export const SaveCTSCustomSenarioData = (payload: any) => {
//     const queryService = new QueryService(BACKEND_API_URL);
//     const postData = async () => {
//         let url = `/saveCTSScenario`;
//         const data = await queryService.runQuery(url, "PUT", payload);
//         return data;
//     };

//     return postData().then((data) => {
//         return data;
//     }).catch((err: any) => {
//         console.log("error in SaveCTSCustomSenarioData API --", err);
//     });
// };

export const getBTGFilterData = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = "/getBTGFilterData";
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the filter data for brands to grow !");
		});
};

export const getBTGGraphData = (
	l1: string,
	divisionId: any,
	customerId: any = null
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	l1 = l1.replace(/&/g, "%26");
	const fetchData = async () => {
		let url = `/getBTGGraphData?l1=${l1}`;
		if (divisionId && !customerId) {
			url = `/getBTGGraphData?l1=${l1}&divisionId=${divisionId}`;
		} else if (!divisionId && customerId) {
			url = `/getBTGGraphData?l1=${l1}&customerId=${customerId}`;
		} else if (!divisionId && !customerId) {
			url = `/getBTGGraphData?l1=${l1}`;
		} else {
			url = `/getBTGGraphData?l1=${l1}&divisionId=${divisionId}&customerId=${customerId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the graph data for brands to grow !");
		});
};

export const getBTGTableData = (
	l1: string,
	l4: string,
	divisionId: any = "",
	customerId: any = ""
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	l1 = l1.replace(/&/g, "%26");
	l4 = l4.replace(/&/g, "%26");
	const fetchData = async () => {
		let url = "";
		if (divisionId && !customerId) {
			url = `/getBTGSelectedL4Data?l1=${l1}&l4=${l4}&divisionId=${divisionId}`;
		} else if (!divisionId && customerId) {
			url = `/getBTGSelectedL4Data?l1=${l1}&l4=${l4}&customerId=${customerId}`;
		} else if (!divisionId && !customerId) {
			url = `/getBTGSelectedL4Data?l1=${l1}&l4=${l4}`;
		} else {
			url = `/getBTGSelectedL4Data?l1=${l1}&l4=${l4}&divisionId=${divisionId}&customerId=${customerId}`;
		}
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the graph data for brands to grow !");
		});
};

export const getSKUFilterData = () => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = "/getSKUFilterData";
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could not fetch the filter data for SKU !");
		});
};

export const getCTSScatterData = async (payload: any, lob: LineofBusiness) => {
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";

	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCTSScatterData${queryString}`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	try {
		const data_1 = await fetchData();
		return data_1;
	} catch {
		console.log("Could Not fetch data");
	}
};
export const getCTSFilterData = async (payload: any, lob?: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";

	const fetchData = async () => {
		let url = `/getCTSFilterData${queryString}`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	try {
		const data_1 = await fetchData();

		return data_1;
	} catch {
		console.log("Could Not fetch data");
	}
};

export const getCTSSummaryData = (payload: any, lob: LineofBusiness) => {
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";

	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getCTSSummaryData${queryString}`;
		const data = await queryService.runQuery(url, "POST", payload);
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const getCPCustomerFilterData = async (payload: {
	projectFlag: string;
	District?: string;
	dateRange?: string;
	customerId?: string;
}, lob: LineofBusiness) => {
	const params = new URLSearchParams({
		lob
	});
	const queryService = new QueryService(BACKEND_API_URL);
	const data: AxiosResponse<any> = await queryService.runQuery(
		"/getCPCustomerFilterData?" + params.toString(),
		"POST",
		payload
	);
	return data;
};

export const getCPWaterFallFilter = async (
	payload: {
		district?: string;
		customer?: string;
		customerClass?: string;
		vendor?: string;
		l1?: string;
		l2?: string;
		l3?: string;
		project?: string;
	},
	lob?: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";
	const data = await queryService.runQuery(
		`/getCPWaterFallFilter${queryString}`,
		"POST",
		payload
	);
	return data;
};

export const getPCDependentWaterFallDataOptimise = async (
	payload: {
		district?: string;
		customer?: string;
		customerClass?: string;
		vendor?: string;
		l1?: string;
		l2?: string;
		l3?: string;
		project?: string;
	},
	lob?: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";
	const data = await queryService.runQuery(
		`/getPCDependentWaterFallDataOptimise${queryString}`,
		"POST",
		payload
	);
	return data;
};

export const getWaterFallDataSouthDivision = async (
	payload: {
		district?: string;
		customer?: string;
		customerClass?: string;
		vendor?: string;
		l1?: string;
		l2?: string;
		l3?: string;
		project?: string;
	},
	lob?: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";
	const data = await queryService.runQuery(
		`/getWaterFallDataSouthDivision${queryString}`,
		"POST",
		payload
	);
	return data;
};

export const getPricingFilters = async (payload: PricingPayload, lob: LineofBusiness) => {
	const queryString = lob ? `?lob=${encodeURIComponent(lob)}` : "";
	const queryService = new QueryService(BACKEND_API_URL);
	const data: AxiosResponse<PricingFilter> = await queryService.runQuery(
		`/getPricingFilters${queryString}`,
		"POST",
		payload
	);
	return data;
};

export const getPricingCustomerList = async (
	payload: PricingPayload,
	opportunity: PricingMinMaxopportunity,
	pageNumber: number,
	lob: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const params = new URLSearchParams({
		pageSize: pageSize + "",
		pageNumber: pageNumber + "",
		order: "desc",
		orderBy: "opportunity",
		lob: lob
	});


	if (lob == "plumbing") {
		params.append("home", payload?.home + "")
		params.append("pc", payload?.pc + "")
	}
	else {
		if (opportunity.min != "") params.append("minOpp", opportunity.min);
		if (opportunity.max != "") params.append("maxOpp", opportunity.max);
	}

	const data: AxiosResponse<ResponseWrapper<PricingCustomerListResponse>> =
		await queryService.runQuery(
			"/getPricingCustomerList?" + params.toString(),
			"POST",
			lob == "plumbing" ? undefined : payload
		);
	return data;
};

export const getPricingDistrictItemList = async (
	payload: PricingPayload,
	opportunity: PricingMinMaxopportunity,
	lob: LineofBusiness
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const params = new URLSearchParams({
		order: "desc",
		orderBy: "opportunity",
		lob: lob
	});
	if (lob == "plumbing") {
		params.append("home", payload?.home + "")
		params.append("pc", payload?.pc + "")
		params.append("bill_customer_id", payload?.bill_customer_id?.[0] + "")
	}
	else {
		if (opportunity.min != "") params.append("minOpp", opportunity.min);
		if (opportunity.max != "") params.append("maxOpp", opportunity.max);
	}


	const data: AxiosResponse<
		ResponseWrapper<PricingDistrictItemListResponse>
	> = await queryService.runQuery(
		"/getPricingDistrictItemrList?" + params.toString(),
		"POST",
		lob == "plumbing" ? undefined : payload
	);
	return data;
};

export const getPricingForItemTemp = async (payload: PricingGraphRequest, lob: LineofBusiness, filterValues: any
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const params = new URLSearchParams({ ...payload, lob });
	if (lob == "plumbing") {
		params.append("home", filterValues?.home + "")
		params.append("pc", filterValues?.pc + "")
	}
	const data: AxiosResponse<ResponseWrapper<PricingGraphDataResponse>> =
		await queryService.runQuery(
			"/getPricingForItemTemp?" + params.toString(),
			"GET"
		);
	return data;
};

export const updateExecutedPrice = async (
	payload: PricingUpdateRejectRequest,
	flag: 2 | 1 | 0,
	rejectFlag: 1 | 0,
	lob: LineofBusiness,
	filterValues: any
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const params = new URLSearchParams({
		flag: flag + "",
		rejectFlag: rejectFlag + "",
		lob: lob
	});
	if (lob == "plumbing") {
		params.append("home", filterValues?.home + "")
		params.append("pc", filterValues?.pc + "")
	}
	const data: AxiosResponse<any> = await queryService.runQuery(
		"/updateExecutedPrice?" + params.toString(),
		"POST",
		payload
	);
	return data;
};
